import { useTranslations } from '@vocab/react';
import { Toggle } from 'braid-design-system';
import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import {
  PRIVATE_JOB,
  TOGGLE_PRESSED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { actionUpdateIsConfidential } from 'src/app/v1/state/modules/formData/isConfidential';
import { actionUpdateIsPrivateAd } from 'src/app/v1/state/modules/tealium/isPrivateAd';
import type { AppState } from 'src/types/appState';

import translations from './.vocab';

export const PrivateAdToggle = () => {
  const { isConfidential } = useSelector(
    (state: AppState) => ({
      isConfidential: state.formData.isConfidential,
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState<boolean>(isConfidential);

  const handleChange = (value: boolean) => {
    const newIsConfidential = value;

    setInputValue(newIsConfidential);
    dispatch(actionUpdateIsConfidential(newIsConfidential));
    dispatch(actionUpdateIsPrivateAd(newIsConfidential));

    const eventData = {
      eventName: TOGGLE_PRESSED,
      toggleType: PRIVATE_JOB,
      toggleState: newIsConfidential ? 'on' : 'off',
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <Toggle
      id="privateAd"
      label={t('private-ad-toggle-label')}
      on={inputValue}
      onChange={handleChange}
    />
  );
};
